module.exports = __webpack_public_path__ + "media/images/ac_templates/201/nvyht-5c1862fa35e08ce60c90faad04dbb359.jpg";